module.exports = __webpack_public_path__ + "media/src/images/progress/dentals_6-29c4103999e9b19d992a9a1a55de5b7e.jpg";